"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentPlanStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TreatmentPlanStatus_Factory = /** @class */ (function () {
    function TreatmentPlanStatus_Factory() {
    }
    TreatmentPlanStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            OrderIndex: model.OrderIndex,
        };
        return result;
    };
    TreatmentPlanStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            OrderIndex: model.OrderIndex,
        };
        return result;
    };
    return TreatmentPlanStatus_Factory;
}());
exports.TreatmentPlanStatus_Factory = TreatmentPlanStatus_Factory;
